import { Skeleton } from '../../../components/ui/skeleton';
import { cn } from '../../../components/ui/utils';

import { formatCompactNumber } from '../lib/format-number';

export type MetricKey = 'impressions' | 'reach' | 'interactions' | 'follower_delta' | 'er';

export type MetricConfig = {
  key: MetricKey;
  label: string;
  isPercent: boolean;
};

export const METRICS: MetricConfig[] = [
  { key: 'impressions', label: 'Показы', isPercent: false },
  { key: 'reach', label: 'Охваты', isPercent: false },
  { key: 'interactions', label: 'Взаимодействия', isPercent: false },
  { key: 'follower_delta', label: 'Подписчики', isPercent: false },
  { key: 'er', label: 'ER', isPercent: true },
];

function formatTotalForButton(value: number | null, isPercent: boolean): string {
  if (value === null) return '—';
  if (isPercent) return `${value.toFixed(2)}%`;
  return formatCompactNumber(value);
}

type MetricButtonProps = {
  config: MetricConfig;
  total: number | null;
  delta: number | null;
  isDeltaLoading: boolean;
  isActive: boolean;
  onClick: () => void;
};

export function MetricButton({
  config,
  total,
  delta,
  isDeltaLoading,
  isActive,
  onClick,
}: MetricButtonProps): JSX.Element {
  const hasDelta = delta !== null && Math.abs(delta) >= (config.isPercent ? 0.001 : 0.5);

  return (
    <button
      onClick={onClick}
      className={cn(
        'flex flex-col items-start gap-0.5 px-4 py-3 rounded-xl border transition-colors text-left min-w-[100px] flex-1',
        isActive
          ? 'border-primary bg-primary/10 text-primary'
          : 'border-border bg-card hover:bg-muted/50 text-foreground'
      )}
    >
      <span
        className={cn(
          'text-xs font-normal leading-tight',
          isActive ? 'text-primary' : 'text-muted-foreground'
        )}
      >
        {config.label}
      </span>
      <div className="flex items-baseline gap-2">
        <span className="font-semibold text-sm tabular-nums leading-tight">
          {formatTotalForButton(total, config.isPercent)}
        </span>
        {isDeltaLoading ? (
          <Skeleton className="h-3 w-10" />
        ) : (
          hasDelta && (
            <span
              className={cn(
                'text-xs tabular-nums leading-tight',
                delta! > 0 ? 'text-emerald-600' : 'text-red-500'
              )}
            >
              {delta! > 0 ? '+' : '−'}
              {config.isPercent
                ? `${Math.abs(delta!).toFixed(2)}%`
                : formatCompactNumber(Math.abs(delta!))}
            </span>
          )
        )}
      </div>
    </button>
  );
}
